import React, { useState} from "react";
import LiveLocationMap from "../../Components/LiveLocationMap/LiveLocationMap";

const LiveLocation = () => {
  const [center] = useState([53.54347, 36.69056]);
  const [text, setText] = useState("");
  const [polygon] = useState({
    type: "Polygon",
    coordinates: [
      [
        [53.4949, 36.689295],
        [53.52434, 36.705901],
        [53.567101, 36.708051],
        [53.602236, 36.692963], 
        [53.549487, 36.675879],
      ],
    ],
  })

  const handleCallback = (childData) =>{
    setText(childData)
  }

  return (
    <div>
      <LiveLocationMap parentCallback = {handleCallback} text={text} center={center} polygon={polygon} />
    </div>
  );
};
export default LiveLocation;
